// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3pyPs","colCheckbox":"styles_colCheckbox__2iPHK"};